// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"0b424a9a","949":"c97ed2fc"}[chunkId] + ".chunk.js";
};